import apiClient from "./apiClient";

const BASE_URL = process.env.REACT_APP_BASE_URL;

export const fetchDiseases = () => {
  return apiClient
    .get(`${BASE_URL}/information/diseases/`)
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      throw err;
    });
};

export const fetchDrugs = () => {
  return apiClient
    .get(`${BASE_URL}/information/drugs/`)
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      throw err;
    });
};

export const saveAdditionalInformation = (data: any) => {
  return apiClient
    .post(`${BASE_URL}/profile/additional_information/`, data)
    .then((response) => {
      return response;
    })
    .catch((err) => {
      throw err;
    });
};

export const payForPro = (data: any) => {
  return apiClient
    .get(
      `${BASE_URL}/test-records/${data.id}/pay_for_pro/?plan_id=${
        data.plan_id
      }${data.discount_code ? `&discount_code=${data.discount_code}` : ""} `
    )
    .then((response) => {
      return response;
    })
    .catch((err) => {
      return err;
    });
};

export const checkTransaction = (code: number) => {
  return apiClient
    .get(`${BASE_URL}/transactions/${code}/`)
    .then((response) => {
      return response;
    })
    .catch((err) => {
      throw err;
    });
};

export const checkDisscount = (planId: number, code: number | string) => {
  return apiClient
    .get(
      `${BASE_URL}/financial/check_disscount?plan_id=${planId}&discount_code=${code}`
    )
    .then((response) => {
      return response;
    })
    .catch((err) => {
      throw err;
    });
};
